import React from "react";

export const Footer: React.FC = () => {
	return (
		<p className="text-center pb-2 w-full">
			© 2023 Built by Soumendra and Sahaj
		</p>
	);
};
